// DES-18590: the office's Contact Us details, typed on the website Settings page and sent to
// members in api/donor-settings. Blank parts are dropped, so the screen shows only what was filled in.

export interface MemberContactPhone {
    label: string | null
    number: string
}

export interface MemberContact {
    addressLines: string[]
    phones: MemberContactPhone[]
    email: string | null
}

interface DonorSettingsContactPayload {
    ContactAddress?: string | null
    ContactPhones?: ReadonlyArray<{ Label?: string | null; Number?: string | null } | null> | null
    ContactEmail?: string | null
}

const trimmed = (value: unknown): string => (typeof value === 'string' ? value.trim() : '')

export const toMemberContact = (payload: DonorSettingsContactPayload | null | undefined): MemberContact => {
    const addressLines = trimmed(payload?.ContactAddress)
        .split(/\r?\n/)
        .map((line) => line.trim())
        .filter((line) => line !== '')

    const phones = (payload?.ContactPhones || [])
        .map((phone) => ({ label: trimmed(phone?.Label) || null, number: trimmed(phone?.Number) }))
        .filter((phone) => phone.number !== '')

    const email = trimmed(payload?.ContactEmail) || null

    return { addressLines, phones, email }
}

export const hasMemberContact = (contact: MemberContact | null | undefined): boolean =>
    !!contact && (contact.addressLines.length > 0 || contact.phones.length > 0 || !!contact.email)
